import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateStageStatusDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  data: CreateStageStatusDTO;
  uid: string;
}

export const useCreateProcessStageStatusQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, uid }: IParams) => {
      return await Api.orders.postStageStatus(uid, data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async (data) => {
      await client.invalidateQueries(['getProcess']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
      return data;
    },
  });
};
